import { Channel } from 'lib-shared-types-channels';
import { AsyncStatus } from './global';
import { Response } from './networkResponseTypes';

export enum QueueThreshold {
  SLAPercentage = 'sla_percentage',
  SLATimeLimit = 'sla_time_limit',
  LongestWait = 'longest_wait',
  AvailableAgents = 'available_agents',
  WaitingConversations = 'waiting_conversations',
}

export type QueueChannelTimeouts = Partial<Record<Channel, number>>;

export type QueueThresholds = Partial<Record<QueueThreshold, number>>;

export interface Queue {
  id: string;
  name: string;
  is_default: boolean;
  is_archived: boolean;
  is_restricted: boolean;
  available_offer_algorithms: Array<string> | null;
  calculation_method: string | null;
  offer_abandoned_conversations: boolean;
  member_list_type: string | null;
  offer_algorithm: string;
  offer_timeout: number | null;
  priority: number | null;
  number_of_teams: number | null;
  number_of_agents: number | null;
  wrapup_timeout: number | null;
  queue_thresholds: QueueThresholds | null;
  is_do_not_offer_enabled: boolean;
  is_preferred_agent_enabled: boolean;
  is_personal_offer_prioritized: boolean;
  do_not_offer_timeouts: QueueChannelTimeouts;
  preferred_agent_timeouts: QueueChannelTimeouts;
  preferred_agent_offline_timeout: number | null;
  personal_agent_offline_timeout: number | null;
}

export type QueuePayload = Omit<
  Queue,
  | 'id'
  | 'available_offer_algorithms'
  | 'calculation_method'
  | 'member_list_type'
  | 'number_of_teams'
  | 'number_of_agents'
>;

export type QueueStateT = {
  queues: Array<Queue>;
  asyncStatus: AsyncStatus;
};

export type QueueResponse = Response<Queue>;
